import { Collections } from "./components/collections/collections";
import { Colors } from "./components/colors/colors";
import { Navigation } from "./components/navigation/navigation";
import { Products } from "./components/products/products";
import { Step } from "./components/step/step";
import { Steps } from "./components/steps/steps";
import { Base } from "./paintConfigurator.base";

export const PaintConfigurator = Object.assign(Base, {
    Collections,
    Steps,
    Step,
    Navigation,
    Colors,
    Products
});
